document.addEventListener('DOMContentLoaded', function() {

    // === HERO CAROUSEL ===
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.hero-dot');
    const heroData = [
        { eyebrow: 'Since 1981', heading: 'Market-Leading Interior Fitout Solutions', body: 'Innovative aluminium partitioning, acoustic door systems, and fitout solutions — trusted by architects and builders across Australia.', buttons: '<a href="https://www.criterionindustries.com.au/pages/specification-support"><button class="btn-primary">Explore Products <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></a><a href="https://www.criterionindustries.com.au/pages/contact-us"><button class="btn-secondary">Get in Touch</button></a>' },
        { eyebrow: 'New Products', heading: 'Innovation That Works', body: 'Explore our new and upcoming products. Register your interest to be the first to know when they\'re available.', buttons: '<a href="https://www.criterionindustries.com.au/pages/new-upcoming-products"><button class="btn-primary">New & Upcoming <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></a>' },
        { eyebrow: 'Acoustic Excellence', heading: '<span class="highlight">Silencio</span> Premium Acoustic Solutions', body: 'Acoustically treated and lab-tested sliding and hinged door systems with industry-leading acoustic ratings.', buttons: '<a href="https://www.criterionindustries.com.au/pages/silencio-range"><button class="btn-primary">Silencio Range <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></a><a href="https://www.criterionindustries.com.au/pages/silencio-range-acoustic-reports"><button class="btn-secondary">View Test Reports</button></a>' },
        { eyebrow: 'Healthcare', heading: 'Trusted in Healthcare', body: 'Hygienic, high-performance cavity and door systems designed for medical spaces across Australia.', buttons: '<a href="https://www.criterionindustries.com.au/blogs/case-studies/a-pioneering-standard-of-healthcare-performance"><button class="btn-primary">Healthcare Solutions <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></a>' }
    ];

    let current = 0;
    let transitioning = false;
    let autoplay;

    function goTo(index) {
        if (transitioning || index === current) return;
        transitioning = true;
        slides.forEach(s => s.classList.remove('active'));
        dots.forEach(d => d.classList.remove('active'));
        slides[index].classList.add('active');
        dots[index].classList.add('active');

        const d = heroData[index];
        document.querySelector('.hero-eyebrow').textContent = d.eyebrow;
        document.getElementById('hero-heading').innerHTML = d.heading;
        document.getElementById('hero-body').textContent = d.body;
        document.getElementById('hero-buttons').innerHTML = d.buttons;

        current = index;
        setTimeout(() => { transitioning = false; }, 1000);
    }

    function next() { goTo((current + 1) % slides.length); }
    function prev() { goTo((current - 1 + slides.length) % slides.length); }
    function startAutoplay() { clearInterval(autoplay); autoplay = setInterval(next, 8000); }
    function stopAutoplay() { clearInterval(autoplay); }

    document.getElementById('hero-next').addEventListener('click', () => { stopAutoplay(); next(); startAutoplay(); });
    document.getElementById('hero-prev').addEventListener('click', () => { stopAutoplay(); prev(); startAutoplay(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { stopAutoplay(); goTo(i); startAutoplay(); }));

    // Touch swipe
    let touchX = 0;
    const hero = document.querySelector('.hero');
    hero.addEventListener('touchstart', e => { touchX = e.changedTouches[0].screenX; }, { passive: true });
    hero.addEventListener('touchend', e => {
        const diff = touchX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) { stopAutoplay(); diff > 0 ? next() : prev(); startAutoplay(); }
    }, { passive: true });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
    startAutoplay();


    // === SCROLL REVEAL ===
    const revealEls = document.querySelectorAll('.reveal');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealEls.forEach(el => el.classList.add('visible'));
    } else {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
        revealEls.forEach(el => observer.observe(el));
    }


    // === STICKY CTA (mobile) ===
    const stickyCta = document.getElementById('sticky-cta');
    if (stickyCta) {
        window.addEventListener('scroll', () => {
            const heroBottom = hero.getBoundingClientRect().bottom;
            stickyCta.classList.toggle('visible', heroBottom < 0);
        }, { passive: true });
    }
});